const REGION_DNS_SEGMENTS = {
  eu: 'eu1',
  us: 'us1',
  ap: 'ap1',
};

/**
 * Converts the region name to starbug dns segment
 *
 * @param region
 * @returns {*}
 */
const regionToDnsSegment = region => REGION_DNS_SEGMENTS[region];

/**
 * Generates a url to merchants details in merchant tooling
 *
 * @param mid Merchant id
 * @param region region as used in urls
 * @param env env as used in urls
 * @param section the url hash part
 * @returns {string} the full merchant url
 */
export const getMerchantDetailsLink = ({ mid, region, environment, section = undefined }) => {
  const regionDns = regionToDnsSegment(region);

  if (!mid || !environment || !regionDns) {
    return '';
  }

  // Because prettier for some reason does not want this line wrapped
  // eslint-disable-next-line max-len
  return `https://merchant-tooling-ui.${environment}.${regionDns}.starbug.klarna.net/merchants/${mid}${
    section ? `#${section}` : ''
  }`;
};
